import { api } from './client'

/**
 * IMP-3 — client dei movimenti della mandante (`PracticePaymentsController`): pagamento, storno (negativo, a parte) e
 * ricorrente (tutto di Equal, mai nelle provvigioni agenti). NON sono incassi: l'incasso vero e' quello bancario; qui e'
 * "riconosciuto dalla mandante". Senza `CanSeeRealAmounts` le chiavi importo sono ASSENTI (ne' null ne' 0), per questo sono
 * opzionali e la UI mostra "—".
 */

export type PaymentKind = 'Pagamento' | 'Storno' | 'Ricorrente'

export const PAYMENT_KIND_LABELS: Record<PaymentKind, string> = {
  Pagamento: 'Pagamento',
  Storno: 'Storno',
  Ricorrente: 'Ricorrente (Equal)',
}

export interface PaymentTotals {
  paid: number
  storni: number
  net: number
  recurring: number
  total: number
}

export interface ContractPaymentRow {
  id: number
  kind: PaymentKind
  postedOn: string
  periodMonth: string
  mandanteName: string | null
  productName: string | null
  sourceRef: string | null
  countsForAgentCommissions: boolean
  amount?: number
}

export interface ContractPayments {
  contractId: number
  canSeeAmounts: boolean
  items: ContractPaymentRow[]
  totals?: PaymentTotals
}

export interface ContactPaymentContract extends Partial<PaymentTotals> {
  contractId: number
  referenceCode: string
  status: string
  signedAt: string | null
  productName: string | null
  movements: number
}

export interface ContactPayments {
  contactId: number
  canSeeAmounts: boolean
  contracts: ContactPaymentContract[]
  contractsWithMovements: number
  totals?: PaymentTotals
}

export type QueueFilter = 'tutti' | 'da_verificare' | 'senza_pratica'

export interface SuggestedContract {
  contractId: number
  referenceCode: string
  status: string
  signedAt: string | null
  customerName: string | null
  operatorName: string | null
}

export interface QueueRow {
  id: number
  queue: 'da_verificare' | 'senza_pratica'
  kind: PaymentKind
  periodMonth: string
  productName: string | null
  customerLabel: string | null
  sourceRef: string | null
  note: string | null
  operatorName: string | null
  suggestedContract: SuggestedContract | null
  amount?: number
}

export interface PaymentQueue {
  items: QueueRow[]
  total: number
  counts: { daVerificare: number; senzaPratica: number }
  canSeeAmounts: boolean
}

export interface AssignResult {
  paymentId: number
  contractId: number
  statusFrom: string | null
  statusTo: string | null
  productApplied: boolean
  productCreated: boolean
}

const BASE = '/api/finance/practice-payments'

export const practicePaymentsApi = {
  byContract: (contractId: number) => api<ContractPayments>(`${BASE}/by-contract/${contractId}`),
  byContact: (contactId: number) => api<ContactPayments>(`${BASE}/by-contact/${contactId}`),
  queue: (filter: QueueFilter, page: number, pageSize: number) =>
    api<PaymentQueue>(`${BASE}/queue?filter=${filter}&page=${page}&pageSize=${pageSize}`),
  /** C-17: cerca la pratica per codice o per cliente (almeno 2 caratteri, al massimo 15 risultati). */
  searchContracts: (q: string) =>
    api<{ items: SuggestedContract[] }>(`${BASE}/contract-search?q=${encodeURIComponent(q)}`),
  /** Senza `contractId` conferma la pratica suggerita. */
  assign: (id: number, contractId?: number) =>
    api<AssignResult>(`${BASE}/${id}/assign`, { method: 'POST', body: JSON.stringify({ contractId: contractId ?? null }) }),
}
